import getDeviceInfo from '@/lib/base/getDeviceInfo';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

export default [
  {
    path: '/more',
    name: 'more',
    component: () => import('@/views/More.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
    },
  },
  {
    path: '/more/certificates',
    name: 'certificates',
    component: () => import('@/views/More/Certificates.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
    },
  },
  {
    path: '/more/certificate/:id',
    name: 'certificate',
    component: () => import('@/views/More/Certificate.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/more/kifus',
    name: 'kifus',
    component: () => import('@/views/More/Kifus.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
    },
  },
  {
    path: '/more/kifu/:createdTime/:gameMode',
    name: 'kifu-preview',
    component: () => import('@/views/More/KifuPreview.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      chessboardRoom: true,
    },
  },
];
